"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const accept_language_parser_1 = __importDefault(require("accept-language-parser"));
const iso3166_1_1 = __importDefault(require("@unly/iso3166-1"));
const error_1 = require("../utils/error");
exports._resolveAcceptLanguage = (supportedLanguages, acceptLanguageHeader, errorHandler = error_1._defaultErrorHandler) => {
    let bestSupportedLanguage;
    try {
        bestSupportedLanguage = accept_language_parser_1.default.pick(supportedLanguages, acceptLanguageHeader, {
            loose: true,
        });
    }
    catch (e) {
        errorHandler(e, error_1.ERROR_LEVELS.ERROR, '_resolveAcceptLanguage', {
            inputs: {
                supportedLanguages,
                acceptLanguageHeader,
            },
        });
    }
    if (bestSupportedLanguage) {
        try {
            return iso3166_1_1.default.to2(iso3166_1_1.default.fromLocale(bestSupportedLanguage)).toLowerCase();
        }
        catch (e) {
            errorHandler(e, error_1.ERROR_LEVELS.ERROR, '_resolveAcceptLanguage', {
                inputs: {
                    supportedLanguages,
                    acceptLanguageHeader,
                },
                bestSupportedLanguage,
            });
        }
    }
};
exports.acceptLanguage = (supportedLanguages, acceptLanguageHeader, errorHandler) => {
    return {
        name: 'acceptLanguage',
        lookup: (options) => {
            return exports._resolveAcceptLanguage(supportedLanguages, acceptLanguageHeader, errorHandler);
        },
        cacheUserLanguage: () => {
        },
    };
};
exports.default = exports.acceptLanguage;
//# sourceMappingURL=acceptLanguage.js.map